import React, {Component} from "react";
import {UserInfoPicker} from "./UserInfoPicker";
import {getData, postData} from "../../../api/doLogin";
import {Button} from "reactstrap";
import {EventClient} from "../../../util/eventClient";

export class UserBriefcaseSelection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      active: true,
      dataLoaded: false,
      preview: null,
      showPicker: false,
      tempData: {}
    };

  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    getData(`admin/users/${this.props.user.id}/briefcasefolders`, {})
      .then((data) => {
        // console.log(data);
        if (data.status === "Success") {
          this.setState({data: data.data.assignedFolders, dataLoaded: true});
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  addData(id, cb) {
    var self = this;
    postData(`admin/users/${this.props.user.id}/briefcasefolderadd`, {bid: id})
      .then((data) => {
        // console.log(data);
        if (data.status === "Success") {
          self.setState({
            data: self.state.data.map((d) => {
              if (d.id === Number(id)) {
                return {...d, access: 1}
              }
              return d;
            })
          }, () => cb());
        } else {
          EventClient.emit("TOAST_ERROR", data.message);
        }
      })
      .catch((err) => {
        EventClient.emit("TOAST_ERROR", error.message);
        console.log(err);
      });
  }

  removeData(id) {
    var self = this;
    postData(`admin/users/${this.props.user.id}/briefcasefolderremove`, {bid: id})
      .then((data) => {
        // console.log(data);
        if (data.status === "Success") {
          self.setState({
            data: self.state.data.map((d) => {
              if (d.id === id) {
                return {...d, access: 0}
              }
              return d;
            })
          })
        } else {
          EventClient.emit("TOAST_ERROR", data.message);
        }
      })
      .catch((err) => {
        EventClient.emit("TOAST_ERROR", error.message);
        console.log(err);
      });
  }

  renderRow() {
    return (row, index) => {
      return (
        <tr key={`${row.id}`}>
          <td style={{padding: 0}}>{row.fullPath}</td>
          <td style={{padding: 0}}>
            <Button style={{padding: "0 .75rem"}} onClick={() => this.removeData(row.id)}>Remove</Button>
          </td>
        </tr>
      )
    }
  }

  renderAddSelection(row, index) {
    return (<option key={`${row.id}`} value={row.id}>{row.fullPath}</option>)
  }

  render() {
    // console.log(this.state.data);
    // return null;
    // access: 0
    // counted: 1
    // display: "MGAs"
    // fullPath: "MGAs"
    // id: 1
    // level: 0
    // parentPath: ""
    // pid: 0
    const selectedOptions = this.state.data.filter((d) => d.access === 1);

    const ignoreIds = selectedOptions.map((s) => ({id: s.id, pid: s.pid}));

    function findChildren(id, data) {
      var children = [];
      var filtered = data.filter((d) => d.pid === id);
      children = children.concat(filtered);
      filtered.forEach((f) => {
        children = children.concat(findChildren(f.id, data));
      });
      return children;
    }

    function findParents(id, data) {
      var parents = [];
      var filtered = data.filter((d) => d.id === id);
      parents = parents.concat(filtered);
      filtered.forEach((f) => {
        parents = parents.concat(findParents(f.pid, data));
      });
      return parents;
    }

    function filterChildrenRecursively(children, data) {
      var filtered = [];
      children.forEach((c) => {
        filtered.push(c);
        filtered = filtered.concat(filterChildrenRecursively(findChildren(c.id, data), data));
      });
      return filtered;
    }

    function filterParentRecursively(parents, data) {
      var filtered = [];
      parents.forEach((c) => {
        filtered.push(c);
        filtered = filtered.concat(filterParentRecursively(findParents(c.pid, data), data));
      });
      return filtered;
    }
    function removeDuplicates(data) {
      var filtered = [];
      data.forEach((d) => {
        if (!filtered.find((f) => f.id === d.id)) {
          filtered.push(d);
        }
      });
      return filtered;
    }

    const addOptions = this.state.data.filter((d) => d.access === 0); //filter ones with direct no access
    // .filter((d) => !selectedOptions.find((s) => s.id === d.pid)) //filter direct children of selected
    // .filter((d) => !selectedOptions.find((s) => s.pid === d.id)); //filter direct parent of selected
    // console.log("Selected", selectedOptions);
    // console.log("added", addOptions);
    const childrenElements = removeDuplicates(filterChildrenRecursively(selectedOptions, addOptions));
    const parentElements = removeDuplicates(filterParentRecursively(selectedOptions, addOptions));
    // console.log("children", childrenElements);
    // console.log("parents", parentElements);

    const filtersAddOptions = addOptions.filter((d) => !childrenElements.find((c) => c.id === d.id))
      .filter((d) => !parentElements.find((c) => c.id === d.id))
      .sort((a, b) => a.fullPath.localeCompare(b.fullPath))
    ;
    return (
      <UserInfoPicker selectedOptions={selectedOptions}
                      title={"Choose Briefcase Folders"}
                      addOptions={filtersAddOptions}
                      columns={["Folder", "Action"]}
                      selectedOptionRender={this.renderRow()}
                      addOptionRender={this.renderAddSelection}
                      onAdd={(id, cb) => this.addData(id, cb)}
                      onClose={() => this.props.onClose && this.props.onClose()}
      />
    )

  }
}


// WEBPACK FOOTER //
// ./src/containers/Admin/Users/UserBriefcaseSelection.js